import { Pipe, PipeTransform } from '@angular/core';
import { WeekDay } from '@angular/common';
import { getISODay, isValid } from 'date-fns';

@Pipe({
  name: 'weekDayKeyFromDate'
})
export class WeekDayTranslationKeyFromDate implements PipeTransform {
  transform(value: Date | string): string {
    const date = new Date(value);
    if (!isValid(date)) {
      return '';
    }

    let weekday = getISODay(date);
    // conversion from iso format (1-7 where 1 is Monday and 7 is Sunday)
    // to angular format (0-6 where Sunday is 0 and Saturday is 6)
    if (weekday === 7) {
      weekday = 0;
    }

    return `SHARED.WEEKDAYS-ABBREV.${WeekDay[weekday]}`.toUpperCase();
  }
}
